<div>
</div>
<div style="position: relative;" width="100%">
  <div class="color-bar">
    <div class="d-flex align-items-center">
      <div [class.btnIcon]="true" [class.mr-2]="true" [class.disabled]="modoEdicion" (click)="modoEdicion = false">
        <img alt="cursor" src="/assets/mouse.svg" class="img-fluid">
      </div>
      <div [class.btnIcon]="true" [class.mr-2]="true" [class.disabled]="!modoEdicion" (click)="modoEdicion = true">
        <img alt="pen" src="/assets/pencil.svg" class="img-fluid">
      </div>
    </div>
    <div  class="d-flex align-items-center">
      <ng-container *ngIf="modoEdicion">
        <ng-container *ngIf="!hideColors">
          <div *ngFor="let color of colores" [class.color-container]="true" [class.selected]="selectedColor == color" (click)="selectedColor = color">
            <div class="color" [style.--color]="color"></div>
          </div>
        </ng-container>
        <ion-button class="btnIcon btnUndo" [disabled]="!strokes.length"  (click)="removeLastStroke()">
          <ion-icon name="arrow-undo"></ion-icon>
        </ion-button>
        <ion-button class="btnIcon btnUndo" *ngIf="AllowClearImage" (click)="clearImage()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ng-container>
    <!-- <ion-button [disabled]="!strokes.length" class="btnIcon" (click)="removeLastStroke()"><ion-icon name="arrow-undo"></ion-icon></ion-button> -->
    </div>
  </div>
  <canvas [style.width]="'calc(100% - 2px)'" [style.height]="'calc(100% - 2px)'" #canvas style="border: 1px solid #c3c3c3;"></canvas>
</div>
